import { addMinutes, format } from 'date-fns'

export default function shiftTimeByMinutes(
  timeString: string,
  minutesToShift: number
) {
  const [hours, minutes, seconds] = timeString.split(':').map(Number)

  const currentTime = new Date()
  currentTime.setHours(hours, minutes, seconds)

  const shiftedTime = addMinutes(currentTime, minutesToShift)

  return format(shiftedTime, 'HH:mm:ss')
}
